 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_frontcover'
 import A1_TITLE from '@/components/01_title'
 import A1A_COPY from '@/components/01a_copy'
 import A2_CONTENTS from '@/components/02_contents'
 import A3_ACKNOWLEDGEMENTS from '@/components/03_acknowledgements'
 import A4_FOREWORD from '@/components/04_foreword'
 import A5_FM01 from '@/components/05_fm01'
 import A6_PROLOGUE from '@/components/06_prologue'
 import A7_FM02 from '@/components/07_fm02'
 import A8_CHAPTER01 from '@/components/08_chapter01'
 import A9_CHAPTER02 from '@/components/09_chapter02'
 import A0_CHAPTER03 from '@/components/10_chapter03'
 import A1_CHAPTER04 from '@/components/11_chapter04'
 import A2_CHAPTER05 from '@/components/12_chapter05'
 import A3_CHAPTER05A from '@/components/13_chapter05a'
 import A4_CHAPTER05B from '@/components/14_chapter05b'
 import A5_CHAPTER05C from '@/components/15_chapter05c'
 import A6_CHAPTER05D from '@/components/16_chapter05d'
 import A7_CHAPTER05E from '@/components/17_chapter05e'
 import A8_CHAPTER05F from '@/components/18_chapter05f'
 import A9_CHAPTER05G from '@/components/19_chapter05g'
 import A0_CHAPTER05H from '@/components/20_chapter05h'
 import A1_CHAPTER05I from '@/components/21_chapter05i'
 import A2_CHAPTER05J from '@/components/22_chapter05j'
 import A3_CHAPTER05K from '@/components/23_chapter05k'
 import A4_CHAPTER05L from '@/components/24_chapter05l'
 import A5_CHAPTER05M from '@/components/25_chapter05m'
 import A6_CHAPTER05N from '@/components/26_chapter05n'
 import A7_CHAPTER05O from '@/components/27_chapter05o'
 import A8_CHAPTER05P from '@/components/28_chapter05p'
 import A9_CHAPTER05Q from '@/components/29_chapter05q'
 import A0_CHAPTER05R from '@/components/30_chapter05r'
 import A1_CHAPTER05S from '@/components/31_chapter05s'
 import A2_CHAPTER05T from '@/components/32_chapter05t'
 import A3_CHAPTER05U from '@/components/33_chapter05u'
 import A4_CHAPTER05V from '@/components/34_chapter05v'
 import A5_CHAPTER05W from '@/components/35_chapter05w'
 import A6_CHAPTER05X from '@/components/36_chapter05x'
 import A7_CHAPTER05Y from '@/components/37_chapter05y'
 import A8_CHAPTER05Z from '@/components/38_chapter05z'
 import A9_CHAPTER05A1 from '@/components/39_chapter05a1'
 import A0_CHAPTER05B1 from '@/components/40_chapter05b1'
 import A1_CHAPTER05C1 from '@/components/41_chapter05c1'
 import A2_CHAPTER05D1 from '@/components/42_chapter05d1'
 import A3_CHAPTER05E1 from '@/components/43_chapter05e1'
 import A4_CHAPTER05F1 from '@/components/44_chapter05f1'
 import A5_CHAPTER05G1 from '@/components/45_chapter05g1'
 import A6_CHAPTER06 from '@/components/46_chapter06'
 import A7_CHAPTER07 from '@/components/47_chapter07'
 import A8_CHAPTER08 from '@/components/48_chapter08'
 import A9_CHAPTER09 from '@/components/49_chapter09'
 import A0_CHAPTER10 from '@/components/50_chapter10'
 import A1_CHAPTER11 from '@/components/51_chapter11'
 import A2_CHAPTER11A from '@/components/52_chapter11a'
 import A3_CHAPTER11B from '@/components/53_chapter11b'
 import A4_CHAPTER11C from '@/components/54_chapter11c'
 import A5_CHAPTER11D from '@/components/55_chapter11d'
 import A6_CHAPTER11E from '@/components/56_chapter11e'
 import A7_CHAPTER11F from '@/components/57_chapter11f'
 import A8_CHAPTER11G from '@/components/58_chapter11g'
 import A9_CHAPTER11H from '@/components/59_chapter11h'
 import A0_CHAPTER11I from '@/components/60_chapter11i'
 import A1_CHAPTER11J from '@/components/61_chapter11j'
 import A2_CHAPTER11K from '@/components/62_chapter11k'
 import A3_CHAPTER11L from '@/components/63_chapter11l'
 import A4_CHAPTER11M from '@/components/64_chapter11m'
 import A5_CHAPTER11N from '@/components/65_chapter11n'
 import A6_CHAPTER11O from '@/components/66_chapter11o'
 import A7_CHAPTER11P from '@/components/67_chapter11p'
 import A8_CHAPTER11Q from '@/components/68_chapter11q'
 import A9_CHAPTER11R from '@/components/69_chapter11r'
 import A0_CHAPTER11S from '@/components/70_chapter11s'
 import A1_CHAPTER11T from '@/components/71_chapter11t'
 import A2_CHAPTER11U from '@/components/72_chapter11u'
 import A3_CHAPTER11V from '@/components/73_chapter11v'
 import A4_CHAPTER11W from '@/components/74_chapter11w'
 import A5_CHAPTER11X from '@/components/75_chapter11x'
 import A6_CHAPTER11Y from '@/components/76_chapter11y'
 import A7_CHAPTER11Z from '@/components/77_chapter11z'
 import A8_CHAPTER11A1 from '@/components/78_chapter11a1'
 import A9_CHAPTER11B1 from '@/components/79_chapter11b1'
 import A0_CHAPTER11C1 from '@/components/80_chapter11c1'
 import A1_CHAPTER11D1 from '@/components/81_chapter11d1'
 import A2_CHAPTER11E1 from '@/components/82_chapter11e1'
 import A3_CHAPTER11F1 from '@/components/83_chapter11f1'
 import A4_CHAPTER11G1 from '@/components/84_chapter11g1'
 import A5_CHAPTER11H1 from '@/components/85_chapter11h1'
 import A6_CHAPTER11I1 from '@/components/86_chapter11i1'
 import A7_CHAPTER11J1 from '@/components/87_chapter11j1'
 import A8_CHAPTER11K1 from '@/components/88_chapter11k1'
 import A9_CHAPTER11L1 from '@/components/89_chapter11l1'
 import A0_CHAPTER11M1 from '@/components/90_chapter11m1'
 import A1_CHAPTER11N1 from '@/components/91_chapter11n1'
 import A2_CHAPTER12 from '@/components/92_chapter12'
 import A3_CHAPTER13 from '@/components/93_chapter13'
 import A4_CHAPTER14 from '@/components/94_chapter14'
 import A5_CHAPTER15 from '@/components/95_chapter15'
 import A6_CHAPTER16 from '@/components/96_chapter16'
 import A7_CHAPTER17 from '@/components/97_chapter17'
 import A8_CHAPTER18 from '@/components/98_chapter18'
 import A9_CHAPTER19 from '@/components/99_chapter19'
 import A00_CHAPTER20 from '@/components/100_chapter20'
 import A01_CHAPTER21 from '@/components/101_chapter21'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/02_contents",
 			"name" : "02_contents",
 			"component" : A2_CONTENTS
 		},
 		{
 			"path" : "/03_acknowledgements",
 			"name" : "03_acknowledgements",
 			"component" : A3_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/04_foreword",
 			"name" : "04_foreword",
 			"component" : A4_FOREWORD
 		},
 		{
 			"path" : "/05_fm01",
 			"name" : "05_fm01",
 			"component" : A5_FM01
 		},
 		{
 			"path" : "/06_prologue",
 			"name" : "06_prologue",
 			"component" : A6_PROLOGUE
 		},
 		{
 			"path" : "/07_fm02",
 			"name" : "07_fm02",
 			"component" : A7_FM02
 		},
 		{
 			"path" : "/08_chapter01",
 			"name" : "08_chapter01",
 			"component" : A8_CHAPTER01
 		},
 		{
 			"path" : "/09_chapter02",
 			"name" : "09_chapter02",
 			"component" : A9_CHAPTER02
 		},
 		{
 			"path" : "/10_chapter03",
 			"name" : "10_chapter03",
 			"component" : A0_CHAPTER03
 		},
 		{
 			"path" : "/11_chapter04",
 			"name" : "11_chapter04",
 			"component" : A1_CHAPTER04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js